function getItems(order, products) {
  if (order && order.items && order.items.items) {
    return  order.items.items;
  }

  if (products) {
    return products;
  }

  return [];
}

module.exports = {
  handle: (e, response) => {
    const { gtmData: { currentStep, option, actionField, products} = {} } = response || {};
    const order = response.order || null;
    const hasOrderData = order && order !== undefined;
    const hasProductsData = products && products!== undefined &&  products.length > 0;
    const hasProductInfo = hasOrderData || hasProductsData;

    if (!hasProductInfo) {
      return;
    }

    const dataLayerInfo = {};
    const newProducts = [];
    const items = getItems(order, products);

    items.forEach((element) => {
      let priceObject = element.price;
      let price = null;

      if (hasOrderData) {
        price = priceObject.sales ? priceObject.sales.value : priceObject.list.value;
      }

      if (price === null && hasProductsData) {
        price = priceObject
      }

      newProducts.push({
        'item_name' : element.productName,
        'item_id' : element.id,
        'price' : price,
        'item_brand' : element.brand,
        'item_category' : element.principalCategory,
        'quantity' : element.quantity
      });
    });

    switch (currentStep) {
      case 2:
        dataLayerInfo.event = 'add_payment_info';
        dataLayerInfo.value = order.priceTotal.replace('$', '');
        dataLayerInfo.value = dataLayerInfo.value.replace('.', '');
        break;
      case 3:
          dataLayerInfo.event = 'add_shipping_info';
          dataLayerInfo.value = actionField.revenue;
          break;
      default:
          return;
    }

    dataLayerInfo.items = newProducts;
    dataLayerInfo.currency = 'CLP';

    // Steps: Shipment = 1, payment = 2, Place Order = 3, submit order=4
    dataLayer.push(dataLayerInfo);
  }
}